import { App } from 'vue'
import vTipDirective from './src/tip.ts'

export default {
	install: (app: App) => {
		app.directive('tip', vTipDirective)
	},
}

export { vTipDirective as vTip }
